import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { UploadStateContext } from './context';
import { isPromise } from '@/utils/object';
import { CnDialog } from '../cn-dialog';
export const UploadConfirm = (props) => {
    const { uploadRef } = props;
    const { onError: _onError, onChange, uploadConfirm = {}, } = useContext(UploadStateContext);
    const [visible, setVisible] = useState(false);
    const { title, content, okProps, cancelProps, footerActions, onOk, onCancel, beforeUploadConfirm, } = uploadConfirm;
    const needUploadConfirm = useMemo(() => {
        return Boolean(beforeUploadConfirm && content);
    }, [content, beforeUploadConfirm]);
    const onChangeRef = useRef(onChange);
    const onErrorRef = useRef(_onError);
    useEffect(() => {
        onChangeRef.current = onChange;
        onErrorRef.current = _onError;
    }, [onChange, _onError]);
    if (!needUploadConfirm)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "cn-ui-m-oss-upload-confirm", onClick: async () => {
                let result = beforeUploadConfirm?.();
                if (isPromise(result))
                    result = await result;
                if (result === false)
                    return;
                if (result === true) {
                    setVisible(true);
                    return;
                }
                // @ts-ignore 忽略私有属性提示
                uploadRef.current?.uploader.onClick();
            } }),
        React.createElement(CnDialog, { title: title, visible: visible, onOk: (e) => {
                setVisible(false);
                // @ts-ignore 忽略私有属性提示
                uploadRef.current?.uploader.onClick();
                onOk?.(e);
            }, onClose: (e) => {
                setVisible(false);
                onCancel?.(e);
            }, onCancel: () => setVisible(false), okProps: okProps, cancelProps: cancelProps, footerActions: footerActions }, content)));
};
